import { GameThumb } from "@workspace/frontend-ui";
import type { FC } from "react";
import type { GameFragment } from "../../types";
import HoverComponent from "./HoverComponent";
import resolveGameHref from "./helpers/resolveGameHref";
import ImageComponent from "./ImageComponent";
import LinkComponent from "./LinkComponent";
import ProviderLinkComponent from "./ProviderLinkComponent";

type Props = {
  item: GameFragment;
  isBridgeSite: boolean;
  translations: Record<string, string>;
};

const GameGridItem: FC<Props> = ({ item, isBridgeSite, translations }) => {
  const gameHref = resolveGameHref(item.href, isBridgeSite);

  return (
    <GameThumb
      game={item}
      link={
        <LinkComponent href={gameHref} className="block shrink-0 w-fit">
          <ImageComponent
            src={item.thumbUrlTab || item.thumbUrl || ""}
            alt={item.name ?? ""}
          />
        </LinkComponent>
      }
      providerLink={
        <ProviderLinkComponent game={item} isBridgeSite={isBridgeSite} />
      }
      hover={<HoverComponent />}
      size="auto"
      translations={translations}
    />
  );
};

export default GameGridItem;
